import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { AccountContact } from '@/modules/AccountContactRelation/interfaces/account-contact'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import RelationFormDialog from '@/modules/AccountContactRelation/components/RelationFormDialog.vue'
import { removeAccountContact } from '@/modules/AccountContactRelation/gql/account-contact.gql'

@Component({
  components: {
    RelationFormDialog,
    AppDialog
  }
})
export default class RelationDialog extends Vue {
  targetRelation: AccountContact | null = null

  relationDialog = {
    actionType: 'new',
    show: false,
    title: 'New Account Contact Relationship',
    disable: false
  }

  deleteRelationDialog = {
    show: false,
    title: 'Delete Account Contact Relationship',
    text: ''
  }

  showRelationEditDialog (e: Event, targetRelation?: AccountContact) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Account Contact Relationship'
    if (targetRelation) {
      this.targetRelation = targetRelation
      actionType = 'edit'
      title = 'Edit Account Contact Relationship'
    }
    this.relationDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideRelationEditDialog () {
    this.targetRelation = null
    this.relationDialog = {
      actionType: 'new',
      show: false,
      title: 'New Account Contact Relationship',
      disable: false
    }
  }

  async deleteRelation (e: Event, relation: AccountContact) {
    e.preventDefault()
    e.stopPropagation()
    this.targetRelation = relation
    this.deleteRelationDialog.show = true
  }

  async deleteRelationPost () {
    if (!this.targetRelation) {
      return
    }
    const { id } = this.targetRelation
    this.deleteRelationDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: removeAccountContact,
        variables: {
          accountContactId: Number(id)
        }
      })
      const res = result.data.removeAccountContact
      if (res) {
        showNotification({
          msg: 'Delete account contact relation successfully',
          type: SnackType.Success
        })
        this.targetRelation = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
